<template>
  <div
    v-if="record.number_orders_driver.value > 0"
    class="lateness-cell"
    :class="{ 'lateness-cell_disabled': !canEdit }"
    @click="canEdit && (isShowOrdersModal = true)"
  >


    <c-sidesheet
      :title="'Опоздания — ' + getParentColumnLabel(parentColumnId) + ' — ' + columnLabel"
      :active="isShowOrdersModal"
      class="lateness-cell-sidesheet"
      @close="closeOrdersModal"
    >
      <c-tabs
        ref="tabs"
        class="orders-number-cell-sidesheet-tabs"
        :active="activeTab"
        :items="tabs.items"
        @change="changeTab"
      />
      <div class="position-relative h-100">
        <div
          id="orders-number-cell-sidesheet-table-shadow-top"
          class="orders-number-cell-sidesheet-table-shadow-top"
        ></div>
        <div
          id="orders-number-cell-sidesheet-table"
          class="orders-number-cell-sidesheet-table"
          @scroll="setShadowsOnScroll"
        >
          <div v-if="isDataLoading" class="orders-number-cell-sidesheet-table-loader">
            <font-awesome-icon :icon="icon" spin />
          </div>
          <c-table-data-orders
            v-if="!isDataLoading"
            ref="table"
            class="lateness-cell-sidesheet-table-table"
            empty-records-label="Записи не найдены"
            :levels="1"
            :disabled-columns="tableData.disabledColumns"
            :is-show-nested-orders-in-routes-tab="true"
            :data="tableData"
            :active-tab="activeTab"
          />
        </div>
        <div
          id="orders-number-cell-sidesheet-table-shadow-bottom"
          class="orders-number-cell-sidesheet-table-shadow-bottom"
        ></div>
      </div>
    </c-sidesheet>
    <div :class="{ 'lateness-cell-value-clickable': !columnId.includes('inTotal') }" class="lateness-cell-value">
      {{ record[columnId].value }}
    </div>
  </div>
  <div v-else class="lateness-cell-value">
    {{ record[columnId].value }}
  </div>
</template>

<script>
import moment from "moment";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import DataTableOrders from "@/pages/calculations/create/additions/sidesheet-additions/data-table-orders";
import Sidesheet from "@/components/sidesheet";
import Tabs from "@/components/tabs";

export default {
  name: "lateness-cell-lateness",
  components: {
    "c-sidesheet": Sidesheet,
    "c-tabs": Tabs,
    "c-table-data-orders": DataTableOrders,
    FontAwesomeIcon,
  },
  props: ["record", "columnId", "calculationData", "columnLabel", "parentColumnId", "canEdit"],
  data() {
    return {
      tabs: {
        items: [
          { label: "Заказы", value: "orders" },
          { label: "Рейсы", value: "routes" },
        ],
      },
      activeTab: "orders",
      isDataLoading: true,
      isShowOrdersModal: false,
      icon: faSpinner,
      routesTableColumns: [
        {
          id: "route",
          label: "Маршрут",
          fullName: "Маршрут",
          type: "string",
          isCategory: 0,
          level: 0,
          colspan: 1,
          characteristic: "",
        },
        {
          id: "start_end",
          label: "Начало/завершение",
          fullName: "Начало/завершение",
          type: "string",
          isCategory: 0,
          level: 0,
          colspan: 1,
          characteristic: "",
        },
        {
          id: "distance",
          label: "Дистанция, км",
          fullName: "Дистанция, км",
          type: "number",
          isCategory: 0,
          level: 0,
          colspan: 1,
          characteristic: "",
        },
        {
          id: "estimated_actual_travel_time",
          label: "Расч./факт. время в пути",
          fullName: "Расч./факт. время в пути",
          type: "string",
          isCategory: 0,
          level: 0,
          colspan: 1,
          characteristic: "",
        },
      ],
      ordersTableColumns: [
        {
          id: "order_number",
          label: "Номер заказа",
          fullName: "Номер заказа",
          type: "string",
          isCategory: 0,
          level: 0,
          colspan: 1,
          characteristic: "",
        },
        {
          id: "delivery_time",
          label: "Время доставки",
          fullName: "Время доставки",
          type: "string",
          isCategory: 0,
          level: 0,
          colspan: 1,
          characteristic: "",
        },
        {
          id: "summ_order",
          label: "Сумма заказа, ฿",
          fullName: "Сумма заказа, ฿",
          type: "number",
          isCategory: 0,
          level: 0,
          colspan: 1,
          characteristic: "",
        },
        {
          id: "processed",
          label: "Обработал",
          fullName: "Обработал",
          type: "string",
          isCategory: 0,
          level: 0,
          colspan: 1,
          characteristic: "",
        },
      ],
      tableData: {
        type: "delivery-orders-table",
        columns: [],
        records: [],
        actions: false,
        enabledFields: [],
        levels: 1,
        disabledColumns: [],
        defaultDisabledColumns: [],
        filteredColumns: [],
        activeFilteredColumns: [],
      },
    };
  },
  watch: {
    isShowOrdersModal(value) {

      if (value) {
        let code = this.columnId.split("_");
        code = code[code.length-1];
        this.tableData.columns = this.ordersTableColumns;
        let orders = [];
        console.log(value, this.columnId, this.record);
        if (this.columnId.indexOf("more_ten")>=0) orders=this.record['orders_'+code][2];
        else if (this.columnId.indexOf("less_five")>=0) orders=this.record['orders_'+code][0];
        else orders=this.record['orders_'+code][1];

        this.$store.dispatch("calculations/getOrdersRoutesLatenessData", orders).then((res) => {
          this.ordersRecords = [];
          const orders = [];
          const routes = [];

          res.routes.forEach((route) => {
            let strp = "-", strf="-";
            let p = route.plan_duration;
            if (p) {
              strp = "";
              let h  = Math.floor(p/3600)
              if (h) strp = h + " ч. ";
              let m = Math.round((p-h*3600)/60);
              strp += (m+" мин");
            }
            p = route.duration;
            if (p) {
              strf = "";
              let h  = Math.floor(p/3600)
              if (h) strf = h + " ч. ";
              let m = Math.round((p-h*3600)/60);
              strf += (m+" мин");
            }
            routes.push({
              route: {
                value: route.orders.map((order) => order.delivery.address).join("<br>"),
              },
              start_end: {
                value: `${route.date} ${route.start_time}<br>` + (route.end_time!==null ? `${route.date} ${route.end_time}` : '&ndash;'),
              },
              distance: {
                value: Math.round(route.distance/1000*100)/100,
              },
              estimated_actual_travel_time: {
                value: strp + " / " +strf,
              },
              orders: route.orders,
              drivers: this.driversLocalItems,
              currentDriver: this.currentDriverLocalValue,
            });
          });

          res.orders.forEach((order) => {
            //console.log(order.delivery);
            orders.push({
              operator: order.operator,
              courier: order.courier,
              order_number: {
                value: order.number.toString(),
              },
              delivery_time: {
                value: order.fact_time,
              },
              summ_order: {
                value: order.sum,
              },
              processed: {
                value: order.operator,
              },
              orderList: {
                sum: order.sum,
                items: order.items.map((item) => ({
                  name: item.name,
                  count: `${item.amount} шт.`,
                  summ: `${Math.round(item.sum)} ฿`,
                })),
              },
              historyChanges: order.history.map((item) => ({
                desc: item.n,
                time: item.t,
                d: item.d,
              })),
              delivery: {
                when_delivered: order.delivery ? `${order.delivery.time[0]} ${order.delivery.time[1]}` : '',
                elapsed_time: this.getTimeDifference(order.start_time, order.close_time),
                point: order.delivery ? order.delivery.address : '',
              },
              isShowRow: true,
            });
          });
          this.ordersRecords = [...orders];
          this.routesTableRecords = [...routes];

          if (this.activeTab === "orders") {
            this.tableData.records = [...orders];
          } else {
            this.tableData.records = [...routes];
          }

          setTimeout(() => {
            this.isDataLoading = false;
          }, 300);
        });
      }
    },
  },
  methods: {
    getParentColumnLabel(id) {
      let label = "";
      switch (id) {
        case "operator":
          label = "Оператор";
          break;
        case "administrator":
          label = "Администратор филиала";
          break;
        case "suhi":
          label = "Повар-сушист";
          break;
        case "pizzamaker":
          label = "Повар-пиццемейкер";
          break;
        case "hot":
          label = "Горячий цех";
          break;
        case "driver":
          label = "Водитель";
          break;
        default:
          label = "";
      }
      return label;
    },
    getTimeDifference(start, end) {
      const startTime = moment(start, "HH:mm");
      const endTime = moment(end, "HH:mm");

      const duration = moment.duration(endTime.diff(startTime));

      const hours = parseInt(duration.asHours(), 10);

      const minutes = parseInt(duration.asMinutes(), 10) % 60;

      if (hours > 0) return `${hours}ч ${minutes} мин`;
      return `${minutes} мин`;
    },
    setShadowsOnScroll() {
      const shadowBottomElement = document.getElementById("orders-number-cell-sidesheet-table-shadow-bottom");
      const shadowTopElement = document.getElementById("orders-number-cell-sidesheet-table-shadow-top");
      const scrollElement = document.getElementById("orders-number-cell-sidesheet-table");
      if (scrollElement !== null) {
        if (scrollElement.scrollHeight > scrollElement.clientHeight) {
          if (scrollElement.scrollTop !== 0) {
            shadowTopElement.classList.add("orders-number-cell-sidesheet-table-shadow-top-active");
          } else if (scrollElement.scrollTop === 0) {
            shadowTopElement.classList.remove("orders-number-cell-sidesheet-table-shadow-top-active");
          }
          if (scrollElement.scrollTop + scrollElement.clientHeight !== scrollElement.scrollHeight) {
            shadowBottomElement.classList.add("orders-number-cell-sidesheet-table-shadow-bottom-active");
          } else {
            shadowBottomElement.classList.remove("orders-number-cell-sidesheet-table-shadow-bottom-active");
          }
        } else {
          shadowTopElement.classList.remove("orders-number-cell-sidesheet-table-shadow-top-active");
          shadowBottomElement.classList.remove("orders-number-cell-sidesheet-table-bottom-active");
        }
      }
    },
    changeTab(value) {
      if (value === "orders") {
        this.isDataLoading = true;
        this.activeTab = "orders";
        this.tableData.columns = this.ordersTableColumns;
        this.tableData.records = this.ordersRecords;
        this.isDataLoading = false;
      } else {
        this.isDataLoading = true;
        this.activeTab = "routes";
        this.tableData.columns = this.routesTableColumns;
        this.tableData.records = this.routesTableRecords;
        this.isDataLoading = false;
      }
    },
    closeOrdersModal() {
      this.$emit("close");
      setTimeout(() => {
        this.isShowOrdersModal = false;
      }, 150);
    },
  },
};
</script>

<style lang="scss" scoped>
.lateness-cell {
  &_disabled {
    cursor: default;
  }

  &-value {
    line-height: 13px;
    font-size: 13px;
    padding: 10px;
    -webkit-transition: 0.2s;
    transition: 0.2s;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    &-clickable {
      color: #0066ff;
      cursor: pointer;
    }
  }

  &-sidesheet {


    ::v-deep .sidesheet__header {
      flex-basis: 0;
      margin-bottom: 20px;
    }

    ::v-deep .sidesheet__wrapper {
      width: calc(100vw - 161px);
      padding: 38px 14px 38px 31px;

      @media screen and (max-width: 1024px) {
        width: calc(100vw - 62px);
      }

      @media screen and (max-width: 700px) {
        padding: 28px 20px;
        max-width: 100%;
        width: 100%;
      }
    }

    &-close {
      position: absolute;
      top: 12px;
      right: 12px;
      display: none;

      @media screen and (max-width: 700px) {
        display: block;
      }
    }

    &-table {
      width: 100%;
      margin-top: 30px;
      margin-top: 29px;
      width: 100%;
      max-height: calc(100% - 75px);
      overflow-x: hidden;
      overflow-y: auto;
      padding-right: 16px;

      &-table {
        width: 100%;

        @media screen and (max-width: 700px) {
          width: calc(100% + 41px);
        }

        &::v-deep .c-table__cell,
        &::v-deep .c-table__column {
          position: static !important;
        }

        &::v-deep td:before,
        &::v-deep th:before {
          background: transparent;
          border: 0 !important;
        }

        &::v-deep td.c-table__record__total__cell:after,
        &::v-deep td.c-table__cell:after {
          background: transparent !important;
        }

        &::v-deep .c-table__header {
          border-bottom: solid 1px #dfe4ef !important;
        }

        &::v-deep .c-table__column {
          border-left-style: solid !important;
          text-align: left !important;
        }

        &::v-deep .c-table__cell {
          border-left-style: solid !important;
        }
      }

      &-loader {
        display: flex;
        font-size: 32px;
        width: 100%;
        height: 100%;
        justify-content: center;
        color: #ff238d;

        @media screen and (max-width: 700px) {
          padding-bottom: 20px;
        }
      }
    }
  }
}

.orders-number-cell-sidesheet-table {
  margin-top: 29px;
  width: 100%;
  max-height: calc(100% - 75px);
  overflow-x: hidden;
  overflow-y: auto;
  padding-right: 16px;
}

</style>
